import prodEnvironment from './environment';
export default {
  ...prodEnvironment,
  isDev: true,
};



// WEBPACK FOOTER //
// ./environments/environment.dev.js